import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  restaurantDirectCheckout: {
    isLoading: false,
    successData: {},
    errorMessage: {},
  },
  riderAvailability: {
    available: false,
    message: "",
  },
  orderTypeAndTime: {
    available: false,
    message: "",
  },
  availableOrderTime: {
    isLoading: false,
    available: false,
    message: "",
    orderTime: {},
  },
  deliveryETA: {},
  specialArea: [],
  dineInPayLater: {
    success: false,
    message: "",
  },
  maxCODAmount: "",
};

export default function orderReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.GET_COD_MAX_AMOUNT_SUCCESS: {
      return {
        ...state,
        maxCODAmount: action.data,
      };
    }
    case actionTypes.RESTAURANT_DIRECT_CHECKOUT: {
      let restaurantDirectCheckout = cloneDeep(state.restaurantDirectCheckout);
      restaurantDirectCheckout.successData = {};
      restaurantDirectCheckout.errorMessage = {};
      restaurantDirectCheckout.isLoading = true;
      return {
        ...state,
        restaurantDirectCheckout: restaurantDirectCheckout,
      };
    }
    case actionTypes.RESTAURANT_DIRECT_CHECKOUT_SUCCESS: {
      let restaurantDirectCheckout = cloneDeep(state.restaurantDirectCheckout);

      restaurantDirectCheckout.isLoading = false;
      restaurantDirectCheckout.successData = action.data;
      return {
        ...state,
        restaurantDirectCheckout: restaurantDirectCheckout,
      };
    }
    case actionTypes.RESTAURANT_DIRECT_CHECKOUT_FAIL: {
      let restaurantDirectCheckout = cloneDeep(state.restaurantDirectCheckout);

      restaurantDirectCheckout.isLoading = false;
      restaurantDirectCheckout.errorMessage = action.data;
      return {
        ...state,
        restaurantDirectCheckout: restaurantDirectCheckout,
      };
    }
    case actionTypes.CHECK_RIDER_AVAILABILITY: {
      let riderAvailability = cloneDeep(state.riderAvailability);

      riderAvailability.available = false;
      riderAvailability.message = "";

      return {
        ...state,
        riderAvailability: riderAvailability,
      };
    }
    case actionTypes.CHECK_RIDER_AVAILABILITY_SUCCESS: {
      let riderAvailability = cloneDeep(state.riderAvailability);

      riderAvailability.available = action.data.available;
      riderAvailability.message = action.data.message;

      return {
        ...state,
        riderAvailability: riderAvailability,
      };
    }
    case actionTypes.CHECK_RIDER_AVAILABILITY_FAIL: {
      let riderAvailability = cloneDeep(state.riderAvailability);

      riderAvailability.available = action.data.available;
      riderAvailability.message = action.data.message;

      return {
        ...state,
        riderAvailability: riderAvailability,
      };
    }
    case actionTypes.CHECK_ORDER_TYPE_AND_TIME: {
      let orderTypeAndTime = cloneDeep(state.orderTypeAndTime);
      orderTypeAndTime.available = false;
      orderTypeAndTime.message = "";
      return {
        ...state,
        orderTypeAndTime: orderTypeAndTime,
      };
    }
    case actionTypes.CHECK_ORDER_TYPE_AND_TIME_SUCCESS: {
      let orderTypeAndTime = cloneDeep(state.orderTypeAndTime);
      orderTypeAndTime.available = true;
      orderTypeAndTime.message = action.data.message;
      return {
        ...state,
        orderTypeAndTime: orderTypeAndTime,
      };
    }
    case actionTypes.CHECK_ORDER_TYPE_AND_TIME_FAIL: {
      let orderTypeAndTime = cloneDeep(state.orderTypeAndTime);

      orderTypeAndTime.available = false;
      orderTypeAndTime.message = action.data.message;
      return {
        ...state,
        orderTypeAndTime: orderTypeAndTime,
      };
    }
    case actionTypes.LOAD_AVAILABLE_ORDER_TIME: {
      return {
        ...state,
        availableOrderTime: {
          ...INITIAL_STATE.availableOrderTime,
          isLoading: true,
        },
      };
    }
    case actionTypes.LOAD_AVAILABLE_ORDER_TIME_SUCCESS: {
      let availableOrderTime = cloneDeep(state.availableOrderTime);
      availableOrderTime.isLoading = false;
      availableOrderTime.available = true;
      availableOrderTime.orderTime = action.data.data;
      return {
        ...state,
        availableOrderTime: availableOrderTime,
      };
    }
    case actionTypes.LOAD_AVAILABLE_ORDER_TIME_FAIL: {
      let availableOrderTime = cloneDeep(state.availableOrderTime);
      availableOrderTime.isLoading = false;
      availableOrderTime.available = false;
      availableOrderTime.message =
        action.data !== undefined ? action.data.message : "";
      return {
        ...state,
        availableOrderTime: availableOrderTime,
      };
    }
    case actionTypes.GET_DELIVERY_ETA: {
      return {
        ...state,
        deliveryETA: {},
      };
    }
    case actionTypes.GET_DELIVERY_ETA_SUCCESS: {
      return {
        ...state,
        deliveryETA: action.data.data,
      };
    }
    case actionTypes.GET_DELIVERY_ETA_FAIL: {
      return {
        ...state,
        deliveryETA: {},
      };
    }

    case actionTypes.GET_SPECIAL_AREA: {
      return {
        ...state,
        specialArea: [],
      };
    }
    case actionTypes.GET_SPECIAL_AREA_SUCCESS: {
      let specialArea = cloneDeep(state.specialArea);
      specialArea = [...action.data.data];
      return {
        ...state,
        specialArea,
      };
    }
    case actionTypes.GET_SPECIAL_AREA_FAIL: {
      return {
        ...state,
        specialArea: [],
      };
    }
    case actionTypes.RESTAURANT_DINE_IN_PAY_LATER:
      return {
        ...state,
      };

    case actionTypes.RESTAURANT_DINE_IN_PAY_LATER_SUCCESS: {
      return {
        ...state,
        dineInPayLater: {
          success: true,
        },
      };
    }
    case actionTypes.RESTAURANT_DINE_IN_PAY_LATER_FAIL: {
      return {
        ...state,
        dineInPayLater: {
          success: false,
          message: action.data,
        },
      };
    }
    default:
      return state;
  }
}
